import apiClient from './api';

export default {
  getAllUsers() {
    return apiClient.get('/users');
  },

  getAllRoles() {
    return apiClient.get('/roles');
  },

  updateUserProfile(userId, userData) {
    return apiClient.put(`/users/${userId}`, userData);
  },

  updateUserRoles(userId, rolesArray) {
    // rolesArray should be an array of role names, e.g., ['admin', 'editor']
    return apiClient.put(`/users/${userId}/roles`, { roles: rolesArray });
  }
};
